import { Controller as BaseController } from "@hotwired/stimulus";

export default class extends BaseController {
  static targets = ["item", "showMore", "input", "label", "selectAll", "unselectAll", "selectAllWrapper", "itemsContainer"];

  connect() {
    this.updateSelectAllVisibility();
  }

  itemTargetConnected(element) {
    element.addEventListener("change", () => {
      this.updateSelectAllVisibility();
    });
  }

  showMore() {
    this.itemTargets.forEach((item) => {
      item.classList.remove("d-none");
      setTimeout(() => {
        item.classList.remove("visibility-hidden");
      }, 100);
    });

    this.showMoreTarget.classList.add("d-none");
  }

  toggleRadioButton(event) {
    event.preventDefault();

    const input = this.inputTargets.find((input) => input.id === event.params.inputId);
    if (!input) return

    if (input.checked) {
      input.checked = false;
    } else {
      input.checked = true;
    }

    // this data param must be set in the component call when required
    if (event.params.autosubmit == true) {
      input.closest("form").requestSubmit();
    }
  }

  toggleSelectAll() {
    this.inputTargets.forEach((input) => {
      input.checked = true;
    });
    this.updateSelectAllVisibility();
  }

  toggleUnselectAll() {
    this.inputTargets.forEach((input) => {
      input.checked = false;
    });
    this.updateSelectAllVisibility();
  }

  updateSelectAllVisibility() {
    if (!this.hasSelectAllWrapperTarget) return;

    const noInputs = this.inputTargets.length === 0;
    const allSelected = this.inputTargets.every((input) => input.checked);

    if (noInputs) {
      this.selectAllWrapperTarget.classList.add("d-none");
      this.itemsContainerTarget.classList.add("d-none");
    } else if (allSelected) {
      this.selectAllWrapperTarget.classList.remove("d-none");
      this.itemsContainerTarget.classList.remove("d-none");
      this.selectAllTarget.classList.add("d-none");
      this.unselectAllTarget.classList.remove("d-none");
    } else {
      this.selectAllWrapperTarget.classList.remove("d-none");
      this.itemsContainerTarget.classList.remove("d-none");
      this.selectAllTarget.classList.remove("d-none");
      this.unselectAllTarget.classList.add("d-none");
    }
  }

  removeInvalidStates() {
    this.inputTargets.forEach((input) => {
      input.classList.remove("is-invalid");
    });
    this.labelTargets.forEach((label) => {
      label.classList.remove("border-danger");
    });
  }
}
